export default {
    title: 'Filtros',
    reset: 'Limpar Filtros',

    labels: {
        active: 'Apenas Ativos',
        blocked: 'Apenas Bloqueados',
        byResellerType: 'Tipo de parceiro',
        canceled: 'Apenas Cancelados',
        createdBetween: 'Criado entre',
        activatedBetween: 'Ativado entre',
        lastActivationNinetyDays: 'Apenas Com 90 Dias Sem Ativação',
        monthYear: 'Mês/Ano',
        onlyBadDebt: 'Apenas Inadimplentes',
        onlyNotPaid: 'Apenas Pendentes',
        onlyPaid: 'Apenas Pagos',
        onlyWaitingReview: 'Apenas Aguardando Revisão',
        onlyTrashed: 'Apenas Excluídos',
        payment_method: 'Forma de Pagamento',
        pending: 'Apenas Pendentes',
        period: 'Período',
        reseller_type_id: 'Tipo de parceiro',
        search: 'Pesquisar',
        status: 'Status',
        trial: 'Apenas Trial',
        pendentCancellationRequisition:
            'Solicitações de cancelamento pendentes',
        resellerStatus: 'Status do Parceiro',
        transmitted: 'Transmitidas',
        id: 'ID',
        action: 'Ação',
        between: 'Entre',
        pendent: 'Pendentes',
        manager: 'Gerente de conta',
        state: 'Estado',
        city: 'Cidade',
        year: 'Ano',
        month: 'Mês',
    },
}
